import type { EntityReference } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getTeamsRefData(): Promise<EntityReference[]> {
  return requestApiJsonOrThrow<EntityReference[]>('admin/reference-data/teams')
}

export const teamsRefDataQuery = {
  queryKey: ['teams-ref-data'],
  queryFn: () => getTeamsRefData(),
}
